import { FormField } from '@crocodille/common';
import { isSome } from '@crocodille/util';
import { useCallback, useEffect, useRef, useState } from 'react';
import Input, { InputProps } from '../input/input';

export interface FileInputProps
  extends Omit<InputProps, 'value' | 'onChange' | 'type'> {
  readonly onChange?: (value: File[] | null) => void;
  readonly clearFile?: boolean;
}

type FieldProps = 'onChange' | 'disabled' | 'onBlur' | 'required';

export function fieldToFileInputProps(
  field: Pick<FormField<File[] | null>, 'error' | FieldProps>,
) {
  return {
    invalid: isSome(field.error),
    onChange: field.onChange,
    onBlur: field.onBlur,
    disabled: field.disabled,
    required: field.required,
  } satisfies Pick<FileInputProps, 'invalid' | FieldProps>;
}

const FileInput: React.FC<FileInputProps> = ({
  onChange,
  clearFile,
  ...props
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [key, setKey] = useState(0);

  const handleChange = useCallback(() => {
    const files = inputRef.current?.files ?? null;

    onChange?.(files ? Array.from(files) : null);
  }, [onChange]);

  useEffect(() => {
    if (clearFile && inputRef.current) {
      setKey((prev) => prev + 1);
      inputRef.current.value = '';
    }
  }, [clearFile, onChange]);

  return (
    <Input
      {...props}
      ref={inputRef}
      type="file"
      onChange={handleChange}
      key={key}
    />
  );
};

export default FileInput;
